import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useTranslation } from "react-i18next"; // Utiliser seulement useTranslation

const DeletionConfirmationModal = ({
  isOpen,
  toggle,
  onConfirm,
  isDeleting,
  deductionToDelete,
  bonusToDelete,
  type = "deduction", // "deduction" ou "bonus"
}) => {
  const { t } = useTranslation();

  const itemToDelete = type === "bonus" ? bonusToDelete : deductionToDelete;

  if (!itemToDelete) return null;

  // Adapter à la structure réelle des données
  const itemName = type === "bonus"
    ? itemToDelete.bonusName || itemToDelete.bonus?.name || itemToDelete.bonus?.label
    : itemToDelete.deduction?.name;

  const confirmText = type === "bonus"
    ? t("are_you_sure_delete")
    : t("are_you_sure_delete_deduction");

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        <i className="fa fa-exclamation-triangle text-warning me-2"></i>
        {t("confirm_deletion")}
      </ModalHeader>
      
      <ModalBody>
        <p className="mb-0">
          {confirmText} <strong className="text-danger">{itemName}</strong> ?
        </p>
        <small className="text-muted">
          {t("this_action_cannot_be_undone")}
        </small>
      </ModalBody>
      
      <ModalFooter>
        <Button
          color="danger"
          onClick={() => onConfirm(itemToDelete)}
          disabled={isDeleting}
          className="me-2"
        >
          {isDeleting ? (
            <>
              <i className="fa fa-spinner fa-spin me-2"></i>
              {t("deleting")}...
            </>
          ) : (
            <>
              <i className="fa fa-trash me-2"></i>
              {t("delete")}
            </>
          )}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={isDeleting}>
          <i className="fa fa-times me-2"></i>
          {t("cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeletionConfirmationModal;